import {spacing} from '@logistics-frontend/blocks/theme/theme'
import type {Optional} from '@logistics-frontend/types'
import {toNumber} from '@logistics-frontend/utils'
import type React from 'react'
import {useCallback} from 'react'

const DEFAULT_SPACING = toNumber(spacing(1))

export function useScrollToErrorField({current}: React.MutableRefObject<Optional<HTMLDivElement>>) {
  return useCallback(() => {
    if (current === undefined) {
      return
    }

    const firstErrorInput = current.querySelector<HTMLInputElement>('[data-error=true]')

    if (firstErrorInput) {
      const {top: formOffset} = current.getBoundingClientRect()

      current.scrollTo({
        top: current.scrollTop + firstErrorInput.getBoundingClientRect().top - (formOffset + DEFAULT_SPACING * 2.5),
      })

      firstErrorInput.focus()
    }
  }, [current])
}
